<template>
  <div class="ht-container ht-container-admin pb-5">
    <div class="mb-4 border bg-white">
      <div
        v-for="message in $store.state.messages.all"
        :key="'message-'+message.id"
        class="message p-2 border-bottom">
        <div class="row">
          <span class="col-9 text-left">
            <strong>{{ message.fromUser.username }}:</strong>
            {{ message.message }}
          </span>
          <span class="message-time col-3 text-muted text-right small">
            4 hours ago
          </span>
        </div>
      </div>
    </div>
    <div>
      <input
        ref="message_to_send"
        type="text"
        class="form-control"
        placeholder="Write a message to send to the chat."
        @keyup="handleKeyup"
        >
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
class Chat extends Vue {

  mounted() {
    this.handleMessages();
  }

  handleMessages() {
    this.$store.dispatch('messages/getAll');
    console.log(this.$store.state.messages[0]);
  }

  handleKeyup(event) {
    if (event.key == 'Enter') {
      this.sendMessage();
    }
  }

  sendMessage() {
    console.log(this.$refs['message_to_send'].value);
    this.$refs['message_to_send'].value = '';
  }
}
export default Chat;
</script>

<style scoped>

.box {
  display: flex;
  flex-direction: column;
  flex-basis: 70%;
  flex-shrink: 1;
  flex-grow: 1;
  background-color: #fff;
  text-align: center;
}

.box > h4 {
  margin: 1.25rem 0 .5rem;
  font-size: .75rem;
  text-transform: uppercase;
  color: #5c6072;
  font-weight: 400;
  line-height: 1.2;
}

.row > .message-time {
  display: none;
}

.message:hover {
  background-color: #fcfcfc;
}

.message:hover .message-time {
  display: block;
}

</style>
